module.exports = [
  {
    name: "Nuke",
    kills: 25,
    activate: function (c, d) {
      return (
        !c.nukeTimer && (c.incStat("n", d), c.startNuke(d), d.nukes++, true)
      );
    },
  },
];
